import React, { useState } from "react";
import DepartmentTable from "./components/DepartmentTable";
import DepartmentAddEditModal from "./components/DepartmentAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';
import { FEATURES } from "../../../../config/features";

const DepartmentModule = ({ user, data, divisionOptions, loading, searchData, createDepartment, updateDepartment }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSave = async (form) => {
    const apiPayload = {
      ...form,
      divisionId: form.divisionId ? parseInt(form.divisionId) : null
    };

    if (selectedItem) {
      let auditInfo = [];

      // Check Code
      if (FEATURES.DEPARTMENT_CODE && form.code !== selectedItem.code) {
        auditInfo.push({ setupArea: "Department", actionTaken: "update", field: "Code", newValue: form.code, oldValue: selectedItem.code || "-", dateSaved: new Date(), savedById: user.id });
      }
      // Check Description
      if (form.description !== selectedItem.description) {
        auditInfo.push({ setupArea: "Department", actionTaken: "update", field: "Description", newValue: form.description, oldValue: selectedItem.description, dateSaved: new Date(), savedById: user.id });
      }
      // Check Division
      if (FEATURES.USE_DIM_DIVISION_DEPARTMENT && apiPayload.divisionId !== selectedItem.divisionId) {
        const newLabel = divisionOptions.find(o => o.value === apiPayload.divisionId)?.label || "-";
        const oldLabel = divisionOptions.find(o => o.value === selectedItem.divisionId)?.label || "-";
        auditInfo.push({ setupArea: "Department", actionTaken: "update", field: "Division", newValue: newLabel, oldValue: oldLabel, dateSaved: new Date(), savedById: user.id });
      }
      // Check Status
      if (form.isActive !== selectedItem.isActive) {
        auditInfo.push({ setupArea: "Department", actionTaken: "update", field: "Is Active?", newValue: form.isActive ? "Active" : "Inactive", oldValue: selectedItem.isActive ? "Active" : "Inactive", dateSaved: new Date(), savedById: user.id });
      }

      const res = await updateDepartment(selectedItem.id, apiPayload, auditInfo);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Department",
        actionTaken: "insert",
        field: "Add",
        newValue: FEATURES.DEPARTMENT_CODE ? `${form.code} - ${form.description}` : form.description,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createDepartment(apiPayload, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <>
      <div className='p-4 space-y-4'>
        <div className="flex justify-between items-center">
          <SearchBar handleFilter={(val) => { setCurrentPage(1); searchData(val); }} />
          <Button
            icon={<AddIcon />}
            name={"Add Department"}
            className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
            onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
          />
        </div>

        <DepartmentTable
          data={data}
          onEdit={handleEdit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>

      <DepartmentAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
        divisionOptions={divisionOptions}
      />
    </>
  );
};

export default DepartmentModule;